import React, { useEffect, useState } from "react";
import { App } from "@capacitor/app";
import { isMobileApp } from "../utils/mobile";
import { compare } from "compare-versions";
import { useAppMetadata } from "./useAppMetadata";
import { WEB_SPA_VERSION } from "..";

interface AppVersion {
  requiresUpdate: boolean;
  requiresForceUpdate: boolean;
  hasNewSpaVersion: boolean;
}

export function useCurrentAppVersion(): AppVersion {
  const [hasNewSpaVersion, setHasNewSpaVersion] = useState<boolean>(false);
  const [requiresUpdate, setRequiresUpdate] = useState<boolean>(false);
  const [requiresForceUpdate, setRequiresForceUpdate] =
    useState<boolean>(false);
  const appMetadata = useAppMetadata();

  useEffect(() => {
    if (!appMetadata) {
      setRequiresUpdate(false);
      setRequiresForceUpdate(false);
    } else if (!isMobileApp) {
      setRequiresUpdate(false);
      setRequiresForceUpdate(false);
      setHasNewSpaVersion(appMetadata.webSpaVersion > WEB_SPA_VERSION);
    } else {
      App.getInfo().then((info) => {
        if (compare(info.version, appMetadata.forceAppVersion, "<")) {
          setRequiresUpdate(false);
          setRequiresForceUpdate(true);
        } else if (compare(info.version, appMetadata.softAppVersion, "<")) {
          setRequiresUpdate(true);
          setRequiresForceUpdate(false);
        } else {
          setRequiresUpdate(false);
          setRequiresForceUpdate(false);
        }
      });
    }
  }, [appMetadata]);

  return {
    requiresUpdate,
    requiresForceUpdate,
    hasNewSpaVersion,
  };
}
